import { createReducer, on, Action, combineReducers } from '@ngrx/store';
import { toroLocationActionTypes } from './toro-location.actions';
import {
    ToroLocationState,
    toroLocationAdapter
} from './toro-location.entity';
import { Toro } from "./../../../api/common/enumerations";
import DeviceTypeId = Toro.DeviceTypeId;
import * as _ from 'lodash';
import { authActionTypes } from './../../../auth/store/auth.actions';

// export const accountAdapter: EntityAdapter<ToroLocation> = createEntityAdapter<ToroLocation>();
export const initialState: ToroLocationState = toroLocationAdapter.getInitialState({
    ids: [],
    entities: null,
    loaded: false,
    currentLocation: null,
    locationDetail: null,
    isDefaultThemeSet: false,
    total: null
});

export const toroLocationReducerObj = createReducer(
    initialState,

    on(toroLocationActionTypes.locationsForAccountLoaded, (state, action) => {

        const temp = toroLocationAdapter.getSelectors((state: ToroLocationState) => state).selectAll;
        let totalCount = state.ids.length;
        return toroLocationAdapter.addMany(action.locations, {
            ...state,
            loaded: action.locations!.length > 0,
            total: state.total + (action.locations && action.locations !== null ? action.locations.length : 0)
        });
    }),

    on(authActionTypes.LogOut, (state, action) => {
        return toroLocationAdapter.removeAll({
            ...state,
            currentLocation: null,
            locationDetail: null,
            loaded: false,
            total: 0
        })
    }),

    on(toroLocationActionTypes.selectLocationDetail, (state, action) => {

        let locDetail = action.locationDetail;

        locDetail.ConnectedDevice =
            locDetail.ConnectedDevices.find(
                (connectedDevice) =>
                    connectedDevice.DeviceTypeId ===
                    DeviceTypeId.Gateway
            );
        return {
            ...state,
            locationDetail: locDetail,
        };
    }),

    on(toroLocationActionTypes.setDefaultThemeSuccess, (state, action) => {
        return {
            ...state,
            isDefaultThemeSet: action.isDefualtThemeSet
        };
    }),

    on(toroLocationActionTypes.createLocationSuccess, (state, action) => {
        if (state.entities[action.location.Id])
            return state;
        else
            return toroLocationAdapter.addOne(action.location, { ...state, total: state.total + 1 });

    }),

    on(toroLocationActionTypes.deleteLocation, (state, action) => {
        return toroLocationAdapter.removeOne(action.locationId, { ...state, total: state.total - 1 });
    }),


    on(toroLocationActionTypes.updateLocationSuccess, (state, action) => {
        return toroLocationAdapter.updateOne(action.update, state);
    }),

    on(toroLocationActionTypes.setLocation, (state, action) => {

        return {
            ...state,
            currentLocation: action.currentLocation
        };
    }),

    on(toroLocationActionTypes.setConnectedDeviceForCurrentLocation, (state, action) => {

        let tempCurrentLocation = state.currentLocation;
        tempCurrentLocation.ConnectedDevice = action.connectedDevice;
        return {
            ...state,
            currentLocation: {}
        };
    }),

    on(toroLocationActionTypes.unsetLocation, (state, action) => {

        return {
            ...state,
            currentLocation: null,
            locationDetail: null
        };
    }),

);

export function toroLocationReducer(state = initialState, action: Action): ToroLocationState {
    return toroLocationReducerObj(state, action);

}

export const toroLocationSelectors = toroLocationAdapter.getSelectors();

